export enum REQUESTS_PATH {
    ORDER_REFERENCE_LABELS = '/CustomerOrders/GoodParts/GetOrderReferenceNumberLabels',
    PARTS_OUTBOUND = '/CustomerOrders/GoodParts/Parts',
    GET_SERVICES = '/CustomerOrders/GoodParts/AvailableServices',
    SERIAL_NUMBERS = '/CustomerOrders/GoodParts/GetInventoryPartSerialNumbers',
    PRE_CHECK = '/CustomerOrders/GoodParts/PreCheck',
    SUBMIT_FULL_ORDER = '/CustomerOrders/GoodParts/Submit',
    SUBMIT_REDUCED_ORDER = '/CustomerOrders/GoodParts/SubmitReduced'
}
